module.exports = __webpack_public_path__ + "static/cardiopatia_dedo-670daf2d2bf073b97b49b2d8ce9903e8.jpg";